import React from 'react';
import { Link, Modal, Stack } from 'library/ui';
import Error from 'parent-portal/provider-reviews/components/Error';

export default function WorkerModalShell({
    title,
    error,
    onClose,
    children,
}: {
    title: string;
    error: boolean;
    onClose: () => void;
    children: React.ReactNode;
}) {
    return (
        <Modal onClose={onClose} title={error ? undefined : title} maxHeight="85vh">
            {error ? (
                <Stack gap="md" align="center">
                    <Error />
                    <Link to="/home" weight="semibold">
                        Back home
                    </Link>
                </Stack>
            ) : (
                children
            )}
        </Modal>
    );
}
